import { render } from "./SSLCertificateTab.vue?vue&type=template&id=a7284cb2&scoped=true"
import script from "./SSLCertificateTab.vue?vue&type=script&lang=js"
export * from "./SSLCertificateTab.vue?vue&type=script&lang=js"

import "./SSLCertificateTab.vue?vue&type=style&index=0&id=a7284cb2&scoped=true&lang=css"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7284cb2"]])

export default __exports__